import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'

/** Uses betRef to trim a coupon with multiple bets into a single bet coupon */
export const getSingularBetFromKambiCoupon = (
  historyCoupon: KambiHistoryCoupon,
  betRef: KambiHistoryCoupon['bets'][0]['betRef']
) => {
  if (historyCoupon.bets.length === 1) return historyCoupon

  const betRow = historyCoupon.bets.filter(x => x.betRef === betRef)

  const couponRowIndex = betRow[0].couponRowIndexes[0]
  const outcomeId = historyCoupon.couponRows.find(x => x.index === couponRowIndex)?.outcomeId
  const outcome = historyCoupon.outcomes.filter(x => x.outcomeId === outcomeId)
  const eventId = outcome[0].eventId
  const betOfferId = outcome[0].betOfferId

  return {
    ...historyCoupon,
    bets: betRow,
    couponRows: historyCoupon.couponRows.filter(x => x.index === couponRowIndex),
    outcomes: outcome,
    events: historyCoupon.events.filter(x => x.eventId === eventId),
    betOffers: historyCoupon.betOffers.filter(x => x.betOfferId === betOfferId),
  }
}
